import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-error404-page',
    templateUrl: './error404-page.component.html',
    styles: [],
    standalone: true,
    imports: [RouterLink]
})
export class Error404PageComponent {

  public goBack(): void {
    window.history.back();
  }

}
